// composables/useSharedUi.ts
import { ref, watchEffect } from 'vue'

const isMobile = ref(false)
const isMessageOpen = ref(false)
const isMessageMenuShown = ref(true)

export function useSharedUi() {

  function toggleMessageBar() {
    isMessageOpen.value = !isMessageOpen.value
    document.documentElement.style.overflow = isMessageOpen.value ? 'hidden' : 'visible'
  }
  function closeMessageMenu() {
    isMessageOpen.value = false
    document.documentElement.style.overflow = 'visible'
  }

  function hideMessageMenu() {
    isMessageMenuShown.value = false
  }

  function windowResized() {
    isMobile.value = window.innerWidth < 1024
  }

  watchEffect(() => {
    window.addEventListener('resize', windowResized)
    windowResized()
  })

  return {
    isMobile,
    isMessageOpen,
    isMessageMenuShown,
    toggleMessageBar,
    closeMessageMenu,
    hideMessageMenu
  }
}
